import React, { useState, useEffect } from 'react'
import './edit.scss'
import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
import {serverTimestamp, setDoc, doc, addDoc, collection } from "firebase/firestore";
import { auth, db, functions, storage } from "../../../firebase";
import { createUserWithEmailAndPassword } from 'firebase/auth';
import Link from '@mui/material/Link';
import { Box, Breadcrumbs, Button, FormControl, InputLabel, MenuItem, Select, TextField, Typography, OutlinedInput, Chip } from '@mui/material'
import { useNavigate } from "react-router-dom"
import { Password } from '@mui/icons-material';
import { getFunctions, httpsCallable } from "firebase/functions";
import { useTheme } from '@material-ui/core/styles';
// import { Box, Button, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { allRegions, allAreas, allOutlets, openList } from '../../../data/dataSource'
import { deleteObject, getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage';
// import { functions } from '../../../firebase';


const roles = [

  { label: 'Partner Admin', value: 'admin' },

  { label: 'Member', value: 'member' },

];

const date = new Date().toDateString()



const Edit = ({inputs, title}) => {

  const [file, setFile ] = useState("")

  const [partnername, setPartnername] = useState("")

  const [partneraddress, setPartneraddress] = useState("")

  const [fulladdress, setFulladdress] = useState("")

  const [email, setEmail] = useState("")

  const [password, setPassword] = useState("")

  const [confirmpassword, setConfirmpassword] = useState("")

  const [telephone, setTelephone] = useState("")

  const [imgpartner, setImgpartner] = useState("")
  
  const [ perc, setPerc ] = useState(null)

  const [partnerfile, setpartnerfile ] = useState("")

  const [role, setRole] = useState("member")

  const [status, setStatus] = useState("active")

  const [partnercode, setPartnercode ] = useState("")

  const [message, setMessage] = useState('')

  const [partnernameerror, setPartnernameerror] = useState("")

  const [partneraddresserror, setPartneraddresserror] = useState("")

  const [emailerror, setEmailerror] = useState("")

  const [passworderror, setPassworderror] = useState("")

  const [confirmpassworderror, setConfirmpassworderror] = useState("")

  const [roleerror, setRoleerror] = useState("")

  const [telephoneerror, setTelephoneerror] = useState("")

  const [error, setError] = useState(false)

  const [ region, setRegion ] = useState("")
  
  const [ area, setArea ] = useState("")

  const [areaList, setAreaList] = useState([])

  // const [categoryList, setCategoryList] = useState([])

  const [resetKeyRegion, setResetKeyRegion] = useState(0);

  const [resetKeyArea, setResetKeyArea] = useState(0);

  const [errorRegion, setErrorRegion] = useState(false)

  const [errorArea, setErrorArea] = useState(false)

  
  const [isloading, setIsloading] = useState(false)

  const [partnerId, setPartnerId] = useState("")

  
  const navigate = useNavigate();




  // const Spinner = () => {
  //   return(
  //     <span className='spinner-container'>
  //         <span className='loading-spinner'></span>
  //     </span>
  //   )
  // }


    useEffect(() => {

      // setIsloading(true)

      const uploadPartnerFile = () => {
  
        const name = new Date().getTime() + partnerfile.name;
        
        const storageRef = ref(storage, "partnerImage/"+name);
  
        const uploadTask = uploadBytesResumable(storageRef, partnerfile);
  
        uploadTask.on('state_changed', 

          (snapshot) => {
          
            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            console.log('Upload is ' + progress + '% done');
            setPerc('Upload is ' + progress.toFixed(0) + '% complete')
            switch (snapshot.state) {
              case 'paused':
                console.log('Upload is paused');
                break;
              case 'running':
                console.log('Upload is running');
                break;
              default:
                break;
            }
          }, 
          (error) => {
            console.log(error)
          }, 
          () => {
           
            getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
              // set((prev) => ({...prev, img: downloadURL}))
              setImgpartner(downloadURL)

              // setIsloading(false)

            });
          }
        );
  
      };
  
      partnerfile && uploadPartnerFile();
  
  }, [partnerfile]);


  const getpartnercode = () => {

    const code = partnername.split(" ")[0]

    setPartnercode(code)

  }

  useEffect(() => {

    getpartnercode()

  }, [partnername])



  useEffect(() => {

    const updatedaddress = `${partnername} - ${partneraddress}, ${area} `

    setFulladdress(updatedaddress)

  }, [partnername, partneraddress])


    const deletepartnerImage = () => {
  
       const deleteRef = ref(storage, imgpartner);
      
              // Delete the file
          deleteObject(deleteRef)

          setImgpartner("")
  
          setpartnerfile("")
  
    }
  



  useEffect(() => {
  
       if(region){
  
          setAreaList(allAreas[region] || []);
      
       } else {
  
          setAreaList([]);
  
          setArea(null)
  
      }
  
  
   }, [region])


   
      const handleChangeRegion = (event) => {
   
        setRegion(event.target.value);
   
         setArea("");
   
        //  setCategory("");
   
   
         setResetKeyArea(prevKey => prevKey + 1);
   
        //  setResetKeyCategory(prevKey => prevKey + 1);
         // setOutletList([]);
   
         if (event.target.value) {
   
   
           setAreaList(allAreas[event.target.value] || []);
   
         } else {
   
           setAreaList([]);
   
         }
   

        if(region !== ""){

          setErrorRegion(false)
          
        }
   
         // setAreaList(allAreas[region] || []);
   
     
     };


      const handleChangeArea = (event) => {

          setArea(event.target.value);

          if(area !== ""){

          setErrorArea(false)
          
        }

      } 




  
  const handleAdd = async(e) => {

    e.preventDefault()
  
    if(partnername === "") {

      return setPartnernameerror('Partner name is required')
      
    }

     if(region === "") {

      return setErrorRegion('Region is required')
    
    }

    if(area === "") {

      return setErrorArea('Area is required')
    
    }

    if(email === "") {

      return setEmailerror('Email is required')
      
    }

     if(password === "") {

      return setPassworderror('Password is required')
      
    }


    if(confirmpassword === "") {

      return setConfirmpassworderror('Confirm Password is required')
      
    }

    if(password !== confirmpassword){

      return setConfirmpassworderror('Password and confirm Password must be the same')
      
    }

    if(telephone === "") {

      return setTelephoneerror('telephone is required')
    
    }

    if(role === "") {

      return setRoleerror('role is required')
      
    }


    setIsloading(true)


    try{

      const res = await createUserWithEmailAndPassword(auth, email, password);

      setPartnerId(res.user.uid)

      await setDoc(doc(db, "partners", res.user.uid), {

          email : email,
          partnername : partnername,
          region : region,
          area : area,
          partneraddress : partneraddress,
          fulladdress : fulladdress,
          telephone : telephone,
          status : status,
          date : date,
          partnercode : partnercode,
          role : role,
          imgpartner: imgpartner,
          partnerId : res.user.uid,
          timeStamp: serverTimestamp(),
    
      })

      const functions = getFunctions();

      const setPartnerClaims = httpsCallable(functions, 'setPartnerClaims');

      setPartnerClaims({

          email: email,

          partnerId: res.user.uid,

      }).then((result) => {

          console.log(result.data.message);

          alert(result.data.message)

          navigate('/partnerReward')
          
          // Force refresh the token on the client
          return auth.currentUser.getIdToken(true);

      }).then(() => {
          console.log("Token refreshed with new claims!");


      });



      
    }catch (err) {
      console.log('error ', err);

      alert('Email already exists')

      return setError(true)

      setIsloading(false)

      
    }finally{

      setIsloading(false)

    }

  }



   const handlePartnername = (e) => {

         setPartnername(e.target.value)

         if(partnername !== ""){

          setPartnernameerror(false)
          
         }

    }

    
    const handlePartneraddress = (e) => {

         setPartneraddress(e.target.value)

         if(partneraddress !== ""){

          setPartneraddresserror(false)
          
         }

    }


    const handleTelephone = (e) => {

          setTelephone(e.target.value)

         if(telephone !== ""){

          setTelephoneerror(false)
          
         }

    }


    const handleEmail = (e) => {

         setEmail(e.target.value)

         if(email !== ""){

          setEmailerror(false)
          
         }

    }


    const handlePassword = (e) => {

         setPassword(e.target.value)

         if(password !== ""){

          setPassworderror(false)
          
         }

    }


    const handleConfirmpassword = (e) => {

         setConfirmpassword(e.target.value)

         if(confirmpassword !== ""){

          setConfirmpassworderror(false)
          
         }

    }




  // console.log(role)

  return (
    <div className="new">
      <Sidebar/>
      <div className="newContainer">
      <Navbar/>
        <div className='top'>
          <div className='topLeft'><h1>New Chillaxia Partner</h1></div>
          
          <div className='topRight'>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/">
              Home
            </Link>
            <Link
              underline="hover"
              color="inherit"
              href="/partnerReward"
            >
              Partner List
            </Link>
            <Typography color="green">New Partner</Typography>
          </Breadcrumbs>
          </div>
        </div>
         <div>
              <span>{message}</span>
            </div>
        <div className='top'>
         
           
            <div className="left">


            <div className='form'  >
         

                  <div style={{display: 'flex', flexDirection:'column', gap:10, width:'49%', marginBottom:20, marginRight:10}}>

                  <p>Partner Name</p>  
                   
                  <TextField
                        type="text"
                        name="title"
                        placeholder="Enter Partner Name eg Chicken Republic"
                        value={partnername}
                        onChange={handlePartnername}
                        style={{width:'100%', backgroundColor:'#f9e3ff', width:'100%', borderWidth:0}}
                        variant="outlined" 
                        sx={{ "& fieldset": { border: "none" } }} 
                      />
                      {
                        partnernameerror &&

                        <p style={{color:'red', fontSize:15, }}>{partnernameerror}</p>

                      }

                </div>

                   <div style={{display: 'flex', flexDirection:'column', gap:10, width:'49%', marginBottom:20, marginRight:10}}>

                  <p>Partner Code</p>  

                  <TextField
                        type="text"
                        name="partnercode"
                        placeholder=""
                        value={partnercode}
                        disabled
                        onChange={handlePartneraddress}
                        style={{width:'100%', backgroundColor:'#f9e3ff', width:'100%', borderWidth:0}}
                        variant="outlined" 
                        sx={{ "& fieldset": { border: "none" } }} 
                      />
                    

                </div>


                <div style={{display: 'flex', flexDirection:'column', gap:10, width:'49%', marginBottom:20, marginRight:10}}>

                   <p>Partner City</p>  
                                 
                  <Box sx={{ minWidth: '49%', backgroundColor:"#f9e3ff", borderWidth: 0 }} >
                    <FormControl fullWidth>
                    <InputLabel id="region" style={{color:'#999', fontWeight:300}}>Select An Outlet City</InputLabel>
                    <Select
                      labelId="region"
                      id="region"
                      value={region}
                      key={resetKeyRegion}
                      label="Region"
                      onChange={handleChangeRegion}
                      // onChange={(e) => setRegion(e.target.value)}
                    >
                      {allRegions.map((item) => { 

                        return(

                          <MenuItem key={item.key} value={item.value}>
                            {item.value}
                          </MenuItem>

                        ) 
                      })} 

                    </Select>
                    </FormControl>
                  </Box>

                    {errorRegion &&
                    <p style={{color:'red', fontSize:15, marginVertical:5}}> {errorRegion}</p>
                    }

                </div>


                
                <div style={{display: 'flex', flexDirection:'column', gap:10, width:'49%', marginBottom:20, marginRight:10}}>

                  <p>Partner Area</p> 

                  <Box sx={{ minWidth: '49%' , backgroundColor:"#f9e3ff" }} >
                    <FormControl fullWidth>
                    <InputLabel id="area" style={{color:'#999', fontWeight:300}}>Select An Outlet Area</InputLabel>
                    <Select
                      labelId="area"
                      id="area"
                      value={area}
                      key={resetKeyArea}
                      label="area"
                      onChange={handleChangeArea}
                      // onChange={change}
                    
                    >

                      {areaList.map((item) => { 

                        return(

                          <MenuItem key={item.key} value={item.value}>
                            {item.value}
                          </MenuItem>

                        ) 
                      })}

                    </Select>
                    </FormControl>
                  </Box>

                  {errorArea &&
                  <p style={{color:'red', fontSize:15, marginVertical:5}}> {errorArea}</p>
                  }

                </div>
                



                <div style={{display: 'flex', flexDirection:'column', gap:10, width:'49%', marginBottom:20, marginRight:10}}>

                  <p>Partner Address</p>  

                  <TextField
                        type="text"
                        name="partneraddress"
                        placeholder="Enter Location Address"
                        value={partneraddress}
                        onChange={handlePartneraddress}
                        style={{width:'100%', backgroundColor:'#f9e3ff', width:'100%', borderWidth:0}}
                        variant="outlined" 
                        sx={{ "& fieldset": { border: "none" } }} 
                      />
                      {
                        partneraddresserror &&

                        <p style={{color:'red', fontSize:15, marginVertical:5 }}>{partneraddresserror}</p>

                      }

                </div>

                 <div style={{display: 'flex', flexDirection:'column', gap:10, width:'49%', marginBottom:20, marginRight:10}}>

                  <p>Partner Telephone</p>  

                  <TextField
                        type="text"
                        name="telephone"
                        placeholder="Enter Location Telephone"
                        value={telephone}
                        onChange={handleTelephone}
                        style={{width:'100%', backgroundColor:'#f9e3ff', width:'100%', borderWidth:0}}
                        variant="outlined" 
                        sx={{ "& fieldset": { border: "none" } }} 
                      />
                      {
                        telephoneerror &&

                        <p style={{color:'red', fontSize:15, marginVertical:5}}>{telephoneerror}</p>

                      }

                </div>


                  <div style={{display: 'flex', flexDirection:'column', gap:10, width:'49%', marginBottom:20, marginRight:10}}>

                  <p>Partner Email</p>  

                  <TextField
                        type="text"
                        name="email"
                        placeholder="Enter Location Email"
                        value={email}
                        onChange={handleEmail}
                        style={{width:'100%', backgroundColor:'#f9e3ff', width:'100%', borderWidth:0}}
                        variant="outlined" 
                        sx={{ "& fieldset": { border: "none" } }} 
                      />
                      {
                        emailerror &&

                        <p style={{color:'red', fontSize:15, marginVertical:5 }}>{emailerror}</p>

                      }

                </div>


{/*                
                  <div style={{display: 'flex', flexDirection:'column', gap:10, width:'49%', marginBottom:20, marginRight:20}}>

                  <TextField

                    type="text"
                    id='email'
                    name="email"
                    placeholder="Enter Partner Email"
                    value={email}
                    onChange={handleEmail}
                    style={{width:'100%', backgroundColor:'#f9e3ff', width:'100%', borderWidth:0}}
                    variant="outlined" 
                    sx={{ "& fieldset": { border: "none" } }} 
                  />

                  {emailerror &&
                  <p style={{color:'red', fontSize:10, marginVertical:5}}> {emailerror}</p>
                  }
            

                  </div> */}

               
                <div style={{display: 'flex', flexDirection:'column', gap:10, width:'49%', marginBottom:20, marginRight:10}}>

                <p>Password</p>  

                <TextField
                
                    type="password"
                    id='password'
                    name="password"
                    placeholder="Enter Partner Password"
                    value={password}
                    onChange={handlePassword}
                    style={{width:'100%', backgroundColor:'#f9e3ff', width:'100%', borderWidth:0}}
                    variant="outlined" 
                    sx={{ "& fieldset": { border: "none" } }} 
                />

                {passworderror &&
                <p style={{color:'red', fontSize:15, marginVertical:5}}> {passworderror}</p>
                }

                </div>

                <div style={{display: 'flex', flexDirection:'column', gap:10, width:'49%', marginBottom:20, marginRight:10}}>

                <p>Confirm Password</p>    

                <TextField
                 
                    type="password"
                    id='confirmpassword'
                    name="confirmpassword"
                    placeholder="Confirm Partner Password"
                    value={confirmpassword}
                    onChange={handleConfirmpassword}
                    style={{width:'100%', backgroundColor:'#f9e3ff', width:'100%', borderWidth:0}}
                    variant="outlined" 
                    sx={{ "& fieldset": { border: "none" } }} 


                />

                {confirmpassworderror &&
                <p style={{color:'red', fontSize:15, marginVertical:5}}> {confirmpassworderror}</p>
                }

                </div>

                <div style={{display: 'flex', flexDirection:'column', gap:10, width:'49%', marginBottom:20, marginRight:10}}>


                    <p>Select Partner Role</p> 

                    <Box sx={{ minWidth: '100%' }}>
                    <FormControl fullWidth>
                    {/* <InputLabel id="role" style={{color:'#999', fontWeight:300}}>Select Your Outlet Role</InputLabel> */}
                    <Select
                      labelId="role"
                      id="role"
                      value={role}
                      label="role"
                      onChange={(e) => setRole(e.target.value)}
                
                    >
              
                    {roles.map((item) => { 
        
                        return(
        
                          <MenuItem key={item.key} value={item.value}>
                          
                              {item.label}
                          
                          </MenuItem>
        
                        ) 
                      })} 
              
                      </Select>
                      </FormControl>
                      </Box>
              
                        <span style={{color:'red', fontSize:10}}>{roleerror && roleerror}</span>

                </div>

                <div style={{display: 'flex', flexDirection:'column', gap:10, width:'100%', marginBottom:20, marginRight:10}}>

                  <p>Partner Logo</p>       

                <div style={{display:'flex', width:'49%'}}>

                 
                  

                  {

                    ( partnerfile && !imgpartner)
                      
                  &&

                    <div style={{display:'flex', width:'100%', height:200, alignItems:'center', justifyContent:'center'
                    }}>

                    <p style={{color:'blue', fontSize:20, fontWeight:700}}>{perc}</p>

                    </div>

                  }

                  {

                    (imgpartner && partnerfile)
                    
                    &&

                    <div style={{display:'flex', width:'100%', flexDirection:'column', gap:10, justifyContent:'center', alignItems:'center'}}>


                    <img
                      src={URL.createObjectURL(partnerfile) }
                      alt=""
                      // className='imgs'
                      style={{width:80, height:80, cursor:'pointer'}}
                      resizeMode = "contain"
                    />

                    <Button onClick={deletepartnerImage} style={{width:'50%',height:60,  backgroundColor:'rgba(246, 109, 91, 1)', color:'#eee'}}>Change Photo</Button>

                    </div>

                    }


                    {

                    (!imgpartner && !partnerfile)

                    &&

                    <div style={{display:'flex', width:'100%', height:200, flexDirection:'column', gap:10, alignItems:'center', justifyContent:'center', backgroundColor:'#eee'}}>
                      <label htmlFor='partnerfile'>
                      {/* < CloudUploadOutlinedIcon style={{width:100}}/> */}
                      <img
                      src="../images/cloud.png"
                      alt=""
                      style={{cursor:'pointer', width:100, height:100, marginLeft:60}}
                      // className='imgs'
                      resizeMode = "contain"
                    />

                      <p style={{fontSize:18, fontWeight:500, color:'#309ff4ff', cursor:'pointer'}}>Tap to upload partner Logo</p>
                      </label>
                      
                        {/* <p style={{fontSize:18, fontWeight:500, color:'#4c4b4bff'}}>Landscape design with dimension (width:500px by height:250px)</p> */}
                      <input type="file" id="partnerfile" onChange= {e => setpartnerfile(e.target.files[0])} style={{display:'none'}}/>
                    </div>



                    }

                    
                </div>

                </div>

                <Button 
                onClick={handleAdd}
                // disabled={perc !== null && perc < 100}
                style={{width:'99%', height:60, backgroundColor:'#9900CC', paddingTop:10, paddingBottom:10, color:'white', marginTop:20}}>{isloading ? "...Loading": 'Add Partner'}
                </Button>
            </div>
            </div>
          </div>
        </div>
      </div>
  )
}

export default Edit
